import { h, render } from 'preact';
import App from './App.jsx';
import './polyfills'
const qs = require('query-string');

const init = (parent,opts) => {


  var {target,...rest} = opts;
  var {theme} = opts;
  const queryString = window.location.search;
  const parsed = qs.parse(queryString);
  if (parsed.sid){
    rest.sid = parsed.sid; 
  }
  var propsToPass = {...rest,url:window.document.URL,domain:window.location.hostname};
  parent._rendered = render((
      <div  className={`foo ${theme}`}>
         { /* <h1>desc: {process.env.APP_DESCRIPTION}</h1> */ }
      <App {...propsToPass} />
      </div>
  ), parent);
};


const authenticate = (token, expiry_date) => {
 // console.log("authenticate callback",token);
  var authArray =  new Array ();
  authArray['key'] = 'authenticate';
  authArray['token'] = token;
  authArray['expiry_date'] = expiry_date;
  //console.log("expiry_date", expiry_date);
  //console.log("token", token);
  if (!token){
    return "pass valid data";
  }
  console.log("authArray", authArray);
  window.postMessage(authArray,"*");
}


const openChat = () => {
  console.log("request came to open");
  window.postMessage("openChat","*");
}

const closeChat = () =>{
  console.log("request came to close");
  window.postMessage("closeChat", "*");
}

const hideChat = () =>{
  window.postMessage("hideChat", "*")
}

const deauthenticate = () =>{
  console.log("deauthenticate called");
  window.postMessage("deauthenticate", "*")
} 
if(process.env.NODE_ENV=="production"){
  
} else {
  //window.Chat = init; 
  //init(document.body,{apiKey:'BEJI1YxWHjgE01NVnrYZy1GOttJu41b5',theme:'tyremarket'});
  //init(document.body,{apiKey:'kWPsIrRqLfQRsNGJX0hphZ07P4QDEmE5',theme:'tyremarket'}); //TVS DEMO
  //init(document.body,{apiKey:'wH9cUz0F0xDb50xRMdwC9E6JEuW36Xz8',theme:'sacred_groves'}); //sacred_groves DEMO
  init(document.body,{apiKey:'SIvqNN7K2wjfLudhC2AFr6hi3NvrzSa8', theme:'tvs_multimode'}); // Forst Demo Project
  
}


export {init,authenticate,openChat,closeChat, hideChat, deauthenticate};


// WEBPACK FOOTER //
// ./index.js